import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { authManager } from '../utils/auth';

const Base_Url = process.env.REACT_APP_API_BASE_URL;

const CampaignVoice = () => {
    const [loading, setLoading] = useState(false);
    const [analytics, setAnalytics] = useState(null);

    useEffect(() => {
    const fetchAnalytics = async () => {
        setLoading(true);
        try {
            const url = `${Base_Url}/membership/campaigns/analytics/voice-campaign`;

            const res = await authManager.authenticatedFetch(url, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });

            if (!res) {
                throw new Error('Empty response from analytics API');
            }

            let payload;
            try {
                payload = await res.json();
            } catch (err) {
                payload = res;
            }

            if (payload?.status === 'success' && payload?.data) {
                setAnalytics(payload.data);
            } else if (payload?.status === 'error') {
                setAnalytics({ clicks: 0, registrations: 0, payments: 0 });
            } else {
                setAnalytics({ clicks: 0, registrations: 0, payments: 0 });
            }
        } catch (err) {
            console.error('Analytics fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    fetchAnalytics();
}, []);


    const safeValue = (...keys) => {
        if (!analytics) return 0;
        for (const k of keys) {
            if (analytics[k] !== undefined && analytics[k] !== null) return analytics[k];
        }
        return 0;
    };

    const clicks = safeValue('clicks', 'totalClicks', 'total_clicks', 'total_clicks_count');
    const registrations = safeValue('registrations', 'totalRegistrations', 'total_registrations', 'signup_count');
    const payments = safeValue('payments', 'totalPayments', 'total_payments', 'payments_count');

    const renderCard = (title, value, iconEl) => (
        <div className="col-12 col-md-6 col-lg-4 col-xl-4 mb-4" key={title}>
            <Link to="#">
                <div className="card">
                    <div className="card-body d-flex text-center align-items-center mt-3 mb-3">
                        <div className="col-8 col-md-8 col-lg-8">
                            <h5 className="card-title w-100 pb-2">{title}</h5>
                            <h2 className="f_black">{value ?? 0}</h2>
                        </div>
                        <div className="col-4 col-md-4 col-lg-4">
                            {iconEl}
                        </div>

                    </div>
                </div>
            </Link>
        </div>
    );

    if (loading) {
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 text-center py-5">Loading analytics...</div>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 txt_lft"> Voice Analytics
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        {renderCard(
                            'Total Clicks',
                            clicks,
                            <i className="fa-solid fa-hand-pointer text-warning fa-3x" />
                        )}
                        {renderCard(
                            'Total Registrations',
                            registrations,
                            <i className="fa-solid fa-user-plus text-success fa-3x" />
                        )}
                        {renderCard(
                            'Total Payments',
                            payments,
                            <i className="fa-solid fa-credit-card text-info fa-3x" />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignVoice;